import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useMemo } from 'react';
import removeFalsyProps from 'utils/ui/removeFalsyProps';
import getArrowPosition, { getPlacements } from './getArrowPosition';
var transformMap = {
  top: 'translateY(-50%) rotate(135deg)',
  right: 'translateX(50%) rotate(225deg)',
  bottom: 'translateY(50%) rotate(-45deg)',
  left: 'translateX(-50%) rotate(45deg)'
};
function useArrowStyles(primaryPlacement, arrowSize) {
  var arrowStyles = useMemo(function () {
    var properties = {
      position: 'absolute',
      display: 'inline-block',
      width: "".concat(arrowSize, "px"),
      height: "".concat(arrowSize, "px"),
      backgroundColor: 'inherit',
      border: 'inherit',
      borderLeftColor: 'transparent',
      borderBottomColor: 'transparent',
      transform: transformMap[primaryPlacement],
      transformOrigin: '50%',
      clipPath: 'polygon(0 0, 100% 0, 100% 100%)',
      filter: 'drop-shadow(black 1px 0px 1px)'
    };
    return properties;
  }, [arrowSize, primaryPlacement]);
  return arrowStyles;
}
var Arrow = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'top' : _props$placement,
    _props$size = props.size,
    size = _props$size === void 0 ? 0 : _props$size,
    _props$distanceFromEd = props.distanceFromEdge,
    distanceFromEdge = _props$distanceFromEd === void 0 ? 8 : _props$distanceFromEd,
    style = props.style;
  var _getPlacements = getPlacements(placement),
    _getPlacements2 = _slicedToArray(_getPlacements, 1),
    primaryPlacement = _getPlacements2[0];
  var baseArrowStyles = useArrowStyles(primaryPlacement, size);
  var defaultArrowPosition = useMemo(function () {
    return getArrowPosition(placement, {
      centerOffset: "-".concat(size / 2, "px"),
      defaultSecondaryValue: distanceFromEdge
    });
  }, [distanceFromEdge, placement, size]);

  // Popper.js likes to pass empty strings for unset properties,
  // (e.g. top: '') we need to filter those out to prevent them
  // from overriding our styles
  var styleWithoutEmptyValues = removeFalsyProps(style);
  var arrowStyle = _objectSpread(_objectSpread(_objectSpread({}, baseArrowStyles), defaultArrowPosition), styleWithoutEmptyValues);
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    style: arrowStyle
  });
});
Arrow.displayName = 'Arrow';
export default Arrow;